
import { Component,Prop, BaseMixins } from '@/lib';
@Component({name:"hi-button-link"})
export default class HiButtonLink extends BaseMixins{
    @Prop({type:String}) labelKey:string;
    @Prop({type:String}) permission:string;
}
